import { FC } from 'react';
import Loader from 'react-loader-spinner';

import Styled from './styles';
import useHook, { ITab } from './hook';
import MainWrapper from '../../shared/main-wrapper';
import Tab from '../../shared/tab';
import colors from '../../assets/colors';

import MyTeamRoomsList from './components/my-team-rooms-list';
import SharedTeamRoomsList from './components/shared-team-rooms-list';

type IProps = {};
const loaderSize = 50;

const TeamRoomsPage: FC<IProps> = () => {
	const { state, tabs, onTab } = useHook();
	const { activeTab, isLoading, isScrolled } = state;

	return (
		<MainWrapper>
			<Styled.FixedTitle>
				<Styled.Shadow isScrolled={isScrolled}>
					<div style={{ padding: '30px 40px 0' }}>
						<Styled.Title text={'Team Rooms'} />
					</div>
					<Styled.Content isScrolled={isScrolled}>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							{tabs.map((tab: ITab, i: number) => (
								<Tab
									key={i}
									title={tab}
									isActive={activeTab === tab}
									totalTabs={tabs.length}
									callback={title => onTab(title)}
								/>
							))}
						</div>
					</Styled.Content>
				</Styled.Shadow>
			</Styled.FixedTitle>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					flexDirection: 'column',
					width: '100%',
					padding: '0 40px',
					marginTop: 56,
				}}
			>
				{isLoading ? (
					<Styled.LoaderWrapper>
						<Loader
							type="TailSpin"
							color={colors.blue}
							height={loaderSize}
							width={loaderSize}
						/>
					</Styled.LoaderWrapper>
				) : (
					<>
						{activeTab === 'Created by me' && (
							<MyTeamRoomsList activeTab={activeTab} />
						)}
						{activeTab === 'Shared with me' && (
							<SharedTeamRoomsList activeTab={activeTab} />
						)}
					</>
				)}
			</div>
		</MainWrapper>
	);
};

export default TeamRoomsPage;
